import {
  Modal,
  PrimaryButton,
  BasicButton,
  Stack,
  Text,
} from "@certn/cascadia";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  List,
  ListItem,
} from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

interface EditRubricWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  rubricName?: string;
  packageCount?: number;
}

export function EditRubricWarningModal({
  isOpen,
  onClose,
  onConfirm,
  rubricName,
  packageCount,
}: EditRubricWarningModalProps) {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} testID="edit-rubric-warning-modal">
      <Dialog width="560px">
        <DialogHeader onClose={onClose}>
          {t("Edit rubric (new version required)")}
        </DialogHeader>
        <DialogContent>
          <Stack gap="space-4">
            <Text style="global/body-primary">
              <strong>{t("Rubric name")}:</strong> {rubricName || ""}
            </Text>
            <Text style="global/body-primary">
              {t(
                "This rubric is currently assigned to {{count}} packages and may be in use for active checks. Editing this rubric will",
                { count: packageCount || 0 }
              )}{" "}
              <strong>{t("create a new version")}.</strong>
            </Text>
            <List type="unordered">
              <ListItem>
                <Text style="global/body-primary">
                  {t(
                    "The new version will apply only to new checks sent after this change"
                  )}
                </Text>
              </ListItem>
              <ListItem>
                <Text style="global/body-primary">
                  {t(
                    "Active checks in progress will continue to use the previous version"
                  )}
                </Text>
              </ListItem>
              <ListItem>
                <Text style="global/body-primary">
                  {t(
                    "Once you edit, previous versions are archived for audit and cannot be changed"
                  )}
                </Text>
              </ListItem>
            </List>
          </Stack>
        </DialogContent>
        <DialogFooter>
          <BasicButton onPress={onClose} testID="cancel-button">
            {t("Cancel")}
          </BasicButton>
          <PrimaryButton
            onPress={() => {
              onConfirm();
              onClose();
            }}
            testID="confirm-button"
          >
            {t("Create new version")}
          </PrimaryButton>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
